<template>
  <div class="developer-accounting">
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
      data-v-step="0"
    >
      <template v-slot:header-title>
        Contas
      </template>
      <template v-slot:header-actions>
        <v-dialog
          :value="modalSimulationActive"
          persistent
          max-width="600"
          @input="createSimulation"
        >
          <template v-slot:activator="{ on }">
            <BaseButton
              type="text"
              color="blueff"
              class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
              v-on="on"
            >
              Simular
            </BaseButton>
          </template>
          <BaseModal
            :show-indeterminate-progress="modalSimulation.showIndeterminateProgress"
            :top-slot-content-title="modalSimulation.topSlotContentTitle"
            :remove-button-close="modalSimulation.removeButtonClose"
            :middle-slot-content-text-highlight="modalSimulation.middleSlotContentTextHighlight"
            :middle-slot-content-text="modalSimulation.middleSlotContentText"
            :middle-check-agree="modalSimulation.middleCheckAgree"
            :bottom-buttons-align="modalSimulation.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="modalSimulation.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="modalSimulation.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="modalSimulation.removeButtonCancel"
            :remove-button-confirm="modalSimulation.removeButtonConfirm"
            :custom-enable-bottom-button-confirm-label="valid"
            @on-cancel="modalSimulation.onCancel"
            @on-confirm="submitSimulation"
          >
            <div style="margin: 0 auto;">
              <v-form
                ref="formSimulation"
                v-model="valid"
              >
                <v-container>
                  <v-row dense>
                    <v-col
                      cols="auto"
                      sm="12"
                    >
                      <BaseInput
                        ref="simulationAmount"
                        v-model="simulation.amount_paid"
                        v-money="amountMask"
                        :rules="[isValid]"
                        qa-identification-name="qa-id-name-simulation-amount"
                        label="Valor Pagamento (R$)"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col
                      cols="auto"
                      sm="12"
                    >
                      <BaseDatePicker
                        ref="simulationDatePaid"
                        name-placeholder="Data Pagamento"
                        :date-value="simulation.datePaid"
                        locale="pt-br"
                        time-zone="UTC"
                        @on-input-date-picker="(value) => { updateDatePicker(simulation, value, 'datePaid') }"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </div>
          </BaseModal>
        </v-dialog>
      </template>
      <v-row class="mt-4">
        <v-col sm="2">
          <v-select
            v-model="filter.initiator"
            :items="getInitiators"
            :rules="[isValid]"
            label="Originador"
          />
        </v-col>
        <v-col sm="2">
          <BaseInput
            v-model="filter.cpf"
            label="Portador"
            :rules="[isValid]"
            clearable
          />
        </v-col>
        <v-col sm="2">
          <BaseDatePicker
            name-placeholder="Data referência"
            :date-value="filter.afterDate"
            locale="pt-br"
            time-zone="UTC"
            :rules="[isValid]"
            @on-input-date-picker="(value) => { updateDatePicker(filter, value, 'afterDate') }"
          />
        </v-col>
        <v-col
          sm="2"
          class="app-align-items-center"
        >
          <BaseButton
            type="text"
            color="blueff"
            class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
            :is-disabled="disabledButtonFilter"
            @click="filterAccounts"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
      <v-tabs
        v-model="tabIndex"
        background-color="transparent"
        class="px-4"
      >
        <v-tab
          v-for="(tab) in tabsList"
          :key="tab"
        >
          {{ tab }}
        </v-tab>
        <v-spacer />
        <template v-if="simulateAccounts">
          <v-tab
            v-for="(tab) in tabsListSimulation"
            :key="tab"
          >
            {{ tab }}
          </v-tab>
        </template>
      </v-tabs>
      <v-tabs-items
        v-model="tabIndex"
        class="tab-details"
      >
        <BaseCard
          :has-main-container="true"
          color="transparent"
        >
          <v-tab-item
            v-for="(tabItem) in totalTabs"
            :key="tabItem"
          >
            <v-card
              v-if="tabIndex == (tabItem-1)"
              color="transparent"
              :elevation="0"
            >
              <v-card-text>
                <v-row dense>
                  <span
                    class="my-4"
                  >
                    {{ balancesTitle }}
                  </span>
                  <v-spacer />
                  <v-dialog
                    :value="isModalAddOrEditActive"
                    persistent
                    max-width="600"
                    @input="changeModalContext('create', {}, tabIndex)"
                  >
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        v-if="dinamicTableAccounts.actionsTable == true"
                        type="text"
                        color="blueff"
                        class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                        v-on="on"
                      >
                        {{ tabIndex == 0 ? 'Adicionar conta' : 'Adicionar movimento' }}
                      </BaseButton>
                    </template>
                    <BaseModal
                      :show-indeterminate-progress="modalAddOrEdit.showIndeterminateProgress"
                      :top-slot-content-title="modalAddOrEdit.topSlotContentTitle"
                      :remove-button-close="modalAddOrEdit.removeButtonClose"
                      :middle-slot-content-text-highlight="modalAddOrEdit.middleSlotContentTextHighlight"
                      :middle-slot-content-text="modalAddOrEdit.middleSlotContentText"
                      :middle-check-agree="modalAddOrEdit.middleCheckAgree"
                      :bottom-buttons-align="modalAddOrEdit.bottomButtonsAlign"
                      :bottom-slot-content-button-cancel-label="modalAddOrEdit.bottomSlotContentButtonCancelLabel"
                      :bottom-slot-content-button-confirm-label="modalAddOrEdit.bottomSlotContentButtonConfirmLabel"
                      :remove-button-cancel="modalAddOrEdit.removeButtonCancel"
                      :remove-button-confirm="modalAddOrEdit.removeButtonConfirm"
                      :custom-enable-bottom-button-confirm-label="contextModal == 'delete' ? true : valid"
                      @on-cancel="modalAddOrEdit.onCancel"
                      @on-confirm="modalAddOrEdit.onConfirm"
                    >
                      <div
                        v-if="contextModal == 'create' || contextModal == 'edit' || contextModal == 'copy'"
                        style="margin: 0 auto"
                      >
                        <v-form
                          v-if="tabIndex == 0"
                          ref="formAddOrEdit"
                          v-model="valid"
                        >
                          <v-container>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  v-model="accountBalance.account"
                                  :rules="[isValid]"
                                  qa-identification-name="qa-id-name-accountBalance-account"
                                  label="Account *"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseDatePicker
                                  name-placeholder="Date *"
                                  :date-value="accountBalance.date"
                                  locale="pt-br"
                                  time-zone="UTC"
                                  qa-identification-name="qa-id-name-accountBalance-date"
                                  :rules="[isValid]"
                                  @on-input-date-picker="(value) => { updateDatePicker(accountBalance, value, 'date') }"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  ref="balanceAmount"
                                  v-model="accountBalance.amount"
                                  v-money="amountMask"
                                  :rules="[isValid]"
                                  qa-identification-name="qa-id-name-accountBalance-balance"
                                  label="Balance *"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                        <v-form
                          v-if="tabIndex == 1"
                          ref="formAddOrEditMovements"
                          v-model="valid"
                        >
                          <v-container>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  v-model="movementForm.data.sk"
                                  disabled
                                  qa-identification-name="qa-id-name-accountMovement-id"
                                  label="ID"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <v-select
                                  v-model="movementForm.id"
                                  :items="['asset', 'payment']"
                                  label="Tipo do movimento*"
                                  qa-identification-name="qa-id-name-accountMovement-movType"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <v-select
                                  v-model="movementForm.type['external-type']"
                                  :items="externalTypeList"
                                  label="Type*"
                                  qa-identification-name="qa-id-name-accountMovement-externalType"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseDatePicker
                                  name-placeholder="Date *"
                                  :date-value="movementForm.data.date"
                                  locale="pt-br"
                                  time-zone="UTC"
                                  qa-identification-name="qa-id-name-accountMovement-date"
                                  :rules="[isValid]"
                                  @on-input-date-picker="(value) => { updateDatePicker(movementForm, value, 'date') }"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  v-model="cpfForm"
                                  qa-identification-name="qa-id-name-accountMovement-cpf"
                                  label="CPF *"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  v-model="movementForm.data['external-id']"
                                  qa-identification-name="qa-id-name-accountMovement-external-id"
                                  label="External ID *"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  ref="movementAmount"
                                  v-model="movementForm.data.amount"
                                  v-money="amountMask"
                                  qa-identification-name="qa-id-name-accountMovement-amount"
                                  label="Amount *"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseDatePicker
                                  name-placeholder="Post Date *"
                                  :date-value="movementForm.data['post-date']"
                                  locale="pt-br"
                                  time-zone="UTC"
                                  qa-identification-name="qa-id-name-accountMovement-post-date"
                                  :rules="[isValid]"
                                  @on-input-date-picker="(value) => { updateDatePicker(movementForm, value, 'post-date') }"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  ref="movementPresentValue"
                                  v-model="movementForm.data['present_value']"
                                  v-money="amountMask"
                                  qa-identification-name="qa-id-name-accountMovement-present_value"
                                  label="Present Value *"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  v-model="movementForm.data['monthly_rate']"
                                  qa-identification-name="qa-id-name-accountMovement-monthly_rate"
                                  label="Monthly Rate *"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col
                                cols="auto"
                                sm="12"
                              >
                                <BaseInput
                                  v-model="movementForm.data['loan_taxes_BR_iof_amount']"
                                  qa-identification-name="qa-id-name-accountMovement-loan_taxes_BR_iof_amount"
                                  label="IOF *"
                                  :rules="[isValid]"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </div>
                    </BaseModal>
                  </v-dialog>
                </v-row>
                <BaseDataTable
                  :items="dinamicTableAccounts.itemsTable"
                  :headers="dinamicTableAccounts.headersTable"
                  :hide-actions="false"
                  :options="pagination"
                  background-color="transparent"
                >
                  <template v-slot:inject-items="scopedItems">
                    <tr
                      v-for="value in scopedItems"
                      :key="value.index"
                    >
                      <template
                        v-for="header, index in dinamicTableAccounts.headersTable"
                      >
                        <td :key="index">
                          <div v-if="value.item.data">
                            <div v-if="header.value == 'amount' || header.value == 'present_value'">
                              {{ value.item.data[header.value] | formatCurrency }}
                            </div>
                            <div v-else>
                              {{ value.item.data[header.value] }}
                            </div>
                          </div>
                          <div v-if="value.item.type">
                            {{ value.item.type[header.value] }}
                          </div>
                          <div v-if="value.item.additionalData">
                            {{ value.item.additionalData[header.value] }}
                          </div>
                          <div v-if="header.value == 'actions'">
                            <div
                              v-if="dinamicTableAccounts.actionsTable == true"
                              class="text-right"
                            >
                              <BaseButton
                                type="text"
                                color="blueff"
                                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                                @click="changeModalContext('edit', value.item, tabIndex, value.index)"
                              >
                                Editar
                              </BaseButton>
                              <BaseButton
                                type="text"
                                color="blueff"
                                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                                @click="changeModalContext('delete', value.item, tabIndex, value.index)"
                              >
                                Apagar
                              </BaseButton>
                              <BaseButton
                                type="text"
                                color="blueff"
                                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                                @click="changeModalContext('copy', value.item, tabIndex, value.index)"
                              >
                                Copiar
                              </BaseButton>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="header.text == 'Balance'">
                              {{ value.item[header.value] | formatCurrency }}
                            </div>
                            <div v-else>
                              {{ value.item[header.value] }}
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </template>
                </BaseDataTable>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </BaseCard>
      </v-tabs-items>
    </BaseCard>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import BaseModal from '../../BaseModal'
import BaseDatePicker from '../../BaseDatePicker'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import BaseDataTable from '../../BaseDataTable'
import { mapGetters, mapActions, mapState } from 'vuex'
import {amountMask} from '../../../directives/moneyMasks'

export default {
  name: 'DeveloperAccounting',
  components: { BaseModal, BaseSnackbar, BaseDatePicker, BaseDataTable},
  mixins: [BaseSnackbarConfiguration],
  data() {
    return {
      valid: false,
      amountMask,
      modalSimulationActive: false,
      isModalAddOrEditActive: false,
      modalAddOrEdit: {},
      modalSimulation: {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Simulação",
        removeButtonClose: true,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: '',
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Salvar",
        removeButtonCancel: false,
        removeButtonConfirm: false,
        onCancel: this.closeModalSimulation,
        onConfirm: null
      },
      simulation: {
        amount_paid: '',
        datePaid: ''
      },
      filter: {
        initiator: '',
        cpf: '',
        afterDate: ''
      },
      editIndex: null,
      tabIndex: 0,
      tabsList: ['Plano de contas', 'Movimentos'],
      tabsListSimulation: ['Simulação - Lançamentos', 'Simulação - Plano de contas', 'Simulação - Movimento de baixa'],
      headersBalances: [
        { text: "Account", value: "account" },
        { text: "Date", value: "date" },
        { text: "Balance", value: "amount" },
        { text: "", value: "actions",sortable: false }
      ],
      headersMovements: [
        { text: "ID", value: "sk" },
        { text: "Type", value: "external-type" },
        { text: "Amount", value: "amount" },
        { text: "Post Date", value: "post-date" },
        { text: "Present Value", value: "present_value" },
        { text: "Monthly Rate", value: "monthly_rate" },
        { text: "IOF", value: "loan_taxes_BR_iof_amount" },
        { text: "", value: "actions",sortable: false }
      ],
      headersSimulationPostings: [
        { text: "Account", value: "account" },
        { text: "Reference Time", value: "posted_at" },
        { text: "Amount", value: "amount" },
      ],
      headersSimulationBalances: [
        { text: "Account", value: "account" },
        { text: "Date", value: "date" },
        { text: "Balance", value: "balance" },
      ],
      headersSimulationMovementsSent: [
        { text: "ID", value: "parent_movement_id" },
        { text: "External Type", value: "externalType" },
        { text: "Origin Type", value: "origin_type" },
        { text: "Date", value: "date" },
        { text: "Amount", value: "amount" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 25,
      },
      simulateAccounts: false,
      accountBalance: {
        account: '',
        date: '',
        amount: ''
      },
      movementForm: {
        data: {
          date: '',
          'post-date': ''
        }
      },
      contextModal:'',
      externalTypeList: ['AJUSTE_CREDITO', 'COMPRA_A_VISTA', 'AJUSTE_DEBITO', 'PARCELAMENTO', 'ROTATIVO', 'PAYMENT'],
      cpfForm: '',
    }
  },
  computed: {
    ...mapGetters(['getInitiators']),
    ...mapState({
      accountBalancesList: (state) => state.common.accountBalancesList,
      accountMovementsList: (state) => state.common.accountMovementsList,
      accountSimulateResponse: (state) => state.common.accountSimulateResponse
    }),
    disabledButtonFilter(){
      return !this.filter.initiator || !this.filter.cpf || !this.filter.afterDate
    },
    balancesTitle(){
      return `initiator:${this.filter.initiator}:wallets:${this.filter.cpf}`
    },
    movementsList() {
      return Array.isArray(this.accountMovementsList.content) ? this.accountMovementsList.content : []
    },
    simulatePostings() {
      return Array.isArray(this.accountSimulateResponse.postings) ? this.accountSimulateResponse.postings : []
    },
    simulateUpdatedForecasts() {
      return Array.isArray(this.accountSimulateResponse.updated_forecasts) ? this.accountSimulateResponse.updated_forecasts : []
    },
    simulateMovementsSent() {
      return Array.isArray(this.accountSimulateResponse.movements_sent) ? this.accountSimulateResponse.movements_sent : []
    },
    dinamicTableAccounts(){
      switch(this.tabIndex) {
        case 0:
          return { itemsTable: this.accountBalancesList, headersTable: this.headersBalances, actionsTable: true }
        case 1:
          return { itemsTable: this.movementsList, headersTable: this.headersMovements, actionsTable: true }
        case 2:
          return { itemsTable: this.simulatePostings, headersTable: this.headersSimulationPostings, actionsTable: false }
        case 3:
          return { itemsTable: this.simulateUpdatedForecasts, headersTable: this.headersSimulationBalances, actionsTable: false }
        case 4:
          return { itemsTable: this.simulateMovementsSent, headersTable: this.headersSimulationMovementsSent, actionsTable: false }
      default:
          return {itemsTable: [], headersTable: [], actionsTable: false}
      }
    },
    totalTabs() {
      return this.tabsList.length + this.tabsListSimulation.length
    }
  },
  async created() {
    this.setDefaultModal()
    this.resetMovementForm()
    await this.apiGetInitiators()
    await this.filterLocalStorage()
    await this.filterAccounts()
  },
  methods: {
    ...mapActions(['apiGetInitiators', 'apiGetAccountMovements', 'apiGetAccountBalances', 'apiSimulateAccounts']),
    updateDatePicker(model, value, attribute) {
      if(model && model.data) {
        model.data[attribute] = value
      } else {
        model[attribute] = value
      }
    },
    closeModalSimulation(){
      this.simulation = { amount_paid: '', datePaid: '' }

      this.$nextTick(() => {
        this.forceResetInputValue(this, 'simulationAmount')
        this.modalSimulationActive = false
      })
    },
    createSimulation(){
      this.modalSimulationActive = true
    },
    async submitSimulation(){
      let payload = {
        rule_id: 'card-posting-rule',
        initiator: this.filter.initiator,
        cpf: this.filter.cpf,
        reference_date: this.filter.afterDate,
        amount_paid: this.parseNumberDecimal(this.simulation.amount_paid.toString()),
        balances: Array.isArray(this.accountBalancesList) ? [...this.accountBalancesList] : [],
        movements: [...this.movementsList]
      }
      try {
        await this.apiSimulateAccounts(payload)
        this.simulateAccounts = true
        this.showFeedback({
          color: 'success',
          message: 'Simulação realizada com sucesso!'
        })
      } catch (e) {
        this.showFeedback({
          color: "error",
          message: 'Erro ao realizar a simulação!'
        })
      } finally {
        this.closeModalSimulation()
      }
    },
    filterAccounts(){
      try {
        localStorage.setItem("state-accounting", JSON.stringify({...this.filter}))
        this.apiGetAccountMovements({ category: 'asset', ...this.filter })
        this.apiGetAccountMovements({ category: 'payment', ...this.filter })
        this.apiGetAccountBalances({ category: 'asset', ...this.filter })
      } catch (e){
        this.showFeedback({
          color: "error",
          message: 'Erro ao buscar dados!',
        })
      }
    },
    filterLocalStorage(){
      let objectLocalStorage = JSON.parse(localStorage.getItem("state-accounting")) || null
      this.filter.initiator = objectLocalStorage.initiator
      this.filter.cpf = objectLocalStorage.cpf
      this.filter.afterDate = objectLocalStorage.afterDate
    },
    parseFieldsAmount(index){
      if(index === 0) {
        this.accountBalance.amount = this.parseNumberDecimal(this.accountBalance.amount).toString()
      } else if (index === 1) {
        this.movementForm.data.amount = this.parseNumberDecimal(this.movementForm.data.amount).toString()
        this.movementForm.data.present_value = this.parseNumberDecimal(this.movementForm.data.present_value).toString()
      }
    },
    crudModalAccounts(action, index){
      const responseMsg = {
        'create': 'criar',
        'delete': 'excluir',
        'edit': 'editar'
      }
      try {
        switch(action){
          case 'create':
            this.parseFieldsAmount(index)

            if(index === 0) {
              this.accountBalancesList.push(this.accountBalance)

            } else if (index === 1) {
              this.movementForm = JSON.parse(JSON.stringify(this.movementForm))
              this.movementForm.data.pk = `program#${this.filter.initiator}`
              this.accountMovementsList.content.push(JSON.parse(JSON.stringify(this.movementForm)))
            }
          break
          case 'edit':
            this.parseFieldsAmount(index)

            if (index === 0 && this.editIndex !== null) {
              this.$set(this.accountBalancesList, this.editIndex, { ...this.accountBalance })

            } else if (index === 1 && this.editIndex !== null) {
              this.$set(this.accountMovementsList.content, this.editIndex, JSON.parse(JSON.stringify(this.movementForm)))
            }
            break
          case 'delete':
            if (index === 0 && this.editIndex !== null) {
              this.accountBalancesList.splice(this.editIndex, 1)

            } else if (index === 1 && this.editIndex !== null) {
              this.accountMovementsList.content.splice(this.editIndex, 1)
            }
            break
          case 'copy':
            this.parseFieldsAmount(index)

            if (index === 0 && this.editIndex !== null) {
              this.accountBalancesList.push(this.accountBalance)

            } else if (index === 1 && this.editIndex !== null) {
              this.accountMovementsList.content.push(JSON.parse(JSON.stringify(this.movementForm)))
            }
          break
        }
      } catch (error) {
        this.showFeedback({
          color: "error",
          message: `Erro ao ${responseMsg[action]} conta!`,
        })
      } finally {
        this.editIndex = null
        this.closeModalAddOrEdit()
      }
    },
    forceFieldsAmount(){
      this.forceResetInputValue(this, 'balanceAmount')
      this.forceResetInputValue(this, 'movementAmount')
      this.forceResetInputValue(this, 'movementPresentValue')
    },
    resetBalanceForm() {
      this.accountBalance = {
        account: '',
        date: '',
        amount: ''
      }
    },
    resetMovementForm(){
      Object.assign(this.movementForm, {
        id: "asset",
        type: {
          id: "loans",
          "external-type": "ROTATIVO",
          title: "CCB"
        },
        data: {
          id: "123",
          status: { name: "Baixada", category: "done" },
          "external_id": "123",
          "external-id": "123",
          date: "2024-01-01",
          amount: "0.00",
          present_value: "0.00",
          loan_interest_rates_monthly_rate: "0.00",
          yearly_effective_rate: "0.00",
          loan_taxes_BR_iof_amount: "0.00",
          loan_bank_fee: "0.00",
          loan_installment_amount: "0.00",
          currency: "BRL",
          loan_number_of_installments: "1",
          number_of_occurrences: "1",
          grace_period: "0",
          frequency: "MONTHS",
          loan_grace_period: "0",
          loan_interest_rates_overdue_fine_amount: "0",
          "taxes.country.BR.iof": "0.00",
          loan_interest_rates_effective_monthly_rate: "0.00",
          pk: "",
          monthly_effective_rate: "0.000000",
          arrears: "0",
          loan_interest_rates_amount_update_frequency: "MONTHS",
          loan_future_value: "0.00",
          fine: "0",
          periods: "1",
          compensatory_rate: "0.000000",
          loan_first_installment_date: "2023-06-05",
          loan_interest_rates_effective_yearly_rate: "0.000000",
          "program-id": "COOPERCARD",
          loan_interest_rates_compensatory_rate: "0.000000",
          loan_interest_rates_overdue_arrears_amount: "0",
          yearly_rate: "0.000000",
          monthly_rate: "0.000000",
          loan_present_value: "0.00",
          periodic_payment: "0.00",
          loan_interest_rates_yearly_rate: "0.000000",
          post_date: "2024-01-31",
          "post-date": "2024-01-31",
          number: "123",
          sk: ""
        },
        from: {
          name: "SELLER",
          data: { type: "seller", "tax-number": "11111111111111" }
        },
        to: {
          name: "BUYER",
          data: { type: "buyer", "tax-number": "" }
        },
        parent: {}
      })
    },
    closeModalAddOrEdit(){
      this.resetBalanceForm()
      this.resetMovementForm()
      this.forceFieldsAmount()
      this.isModalAddOrEditActive = false
      this.setDefaultModal()
    },
    setDefaultModal(){
      Object.assign(this.modalAddOrEdit, {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Adicionar conta",
        removeButtonClose: true,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Salvar",
        middleCheckAgree: null,
        removeButtonCancel: false,
        removeButtonConfirm: false,
        onCancel: this.closeModalAddOrEdit,
        onConfirm: () => this.crudModalAccounts('create'),
      })
    },
    changeModalContext(context, item = {}, index = null, listIndex = null){
      this.editIndex = listIndex

      if(context == 'create'){
        this.contextModal = context

        if(index === 1) {
          this.cpfForm = this.filter.cpf

          this.movementForm.to.data['tax-number'] = this.filter.cpf
          const cpf = this.movementForm.id === "asset" ? this.movementForm.to.data["tax-number"] : this.movementForm.from.data["tax-number"]
          this.movementForm.data.sk = `${this.movementForm.id}#${this.movementForm.data.date}#${cpf}#${this.movementForm.data["external-id"]}`
        }

        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: index == 0 ? "Adicionar conta" : "Adicionar movimento",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Adicionar",
            onConfirm: () => this.crudModalAccounts('create', index)
          }
        )
      } else if(context == 'edit') {
        this.contextModal = context
        if (index === 0) {
          this.$nextTick(() => {
            this.accountBalance = Object.assign({}, item)
          })

          if(this.$refs.balanceAmount){
            this.$refs.balanceAmount[0].$el.getElementsByTagName('input')[0].value = this.parseNumberDecimal(`${item.amount}`.replace('.', ',')).toFixed(2)
          }

        } else if (index === 1) {
          this.$nextTick(() => {
            this.movementForm = Object.assign({}, item)
          })

          if(this.$refs.movementAmount ){
            this.$refs.movementAmount[0].$el.getElementsByTagName('input')[0].value = this.parseNumberDecimal(`${item.data.amount}`.replace('.', ',')).toFixed(2)
          }

          if(this.$refs.movementPresentValue ){
            this.$refs.movementPresentValue[0].$el.getElementsByTagName('input')[0].value = this.parseNumberDecimal(`${item.data.present_value}`.replace('.', ',')).toFixed(2)
          }
        }

        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: index == 0 ? "Editar conta" : "Editar movimento",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Salvar",
            onConfirm: () => this.crudModalAccounts('edit', index)
          }
        )
      } else if(context == 'delete') {
        this.contextModal = context
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: index == 0 ? "Excluir conta" : "Excluir movimento",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Excluir",
            middleSlotContentText: `Tem certeza que deseja ${index == 0 ? 'essa conta' : 'esse movimento'}?`,
            onConfirm: () => this.crudModalAccounts('delete', index)
          }
        )
      } else if(context == 'copy') {
        this.contextModal = context
        if (index === 0) {
          this.$nextTick(() => {
            this.accountBalance = Object.assign({}, item)
          })

          if(this.$refs.balanceAmount){
            this.$refs.balanceAmount[0].$el.getElementsByTagName('input')[0].value = this.parseNumberDecimal(`${item.amount}`.replace('.', ',')).toFixed(2)
          }

        } else if (index === 1) {
          this.$nextTick(() => {
            this.movementForm = Object.assign({}, item)
          })

          if(this.$refs.movementAmount ){
            this.$refs.movementAmount[0].$el.getElementsByTagName('input')[0].value = this.parseNumberDecimal(`${item.data.amount}`.replace('.', ',')).toFixed(2)
          }

          if(this.$refs.movementPresentValue ){
            this.$refs.movementPresentValue[0].$el.getElementsByTagName('input')[0].value = this.parseNumberDecimal(`${item.data.present_value}`.replace('.', ',')).toFixed(2)
          }
        }

        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: index == 0 ? "Copiar conta" : "Copiar movimento",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Copiar",
            onConfirm: () => this.crudModalAccounts('copy', index)
          }
        )
      }
      this.isModalAddOrEditActive = true
    },
  }
}
</script>
<style scoped>
.tab-details {
  background-color: var(--v-grayf8-base)!important;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}
</style>
